var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M8.94 18.66c6.226 0 9.63-5.159 9.63-9.632 0-.147-.002-.293-.009-.438.661-.478 1.236-1.074 1.689-1.753-.607.27-1.26.451-1.944.533.699-.419 1.235-1.082 1.489-1.872-.654.388-1.379.67-2.15.822-.618-.658-1.497-1.07-2.471-1.07-1.87 0-3.386 1.516-3.386 3.385 0 .265.03.524.088.772-2.813-.142-5.308-1.489-6.978-3.537-.29.5-.458 1.081-.458 1.701 0 1.175.598 2.212 1.506 2.818-.555-.017-1.077-.17-1.533-.423v.043c0 1.64 1.167 3.008 2.716 3.318-.285.078-.584.12-.893.12-.218 0-.43-.022-.636-.061.43 1.345 1.68 2.323 3.162 2.35-1.159.909-2.618 1.45-4.204 1.45-.273 0-.543-.016-.808-.047 1.498.96 3.277 1.52 5.19 1.52"}));
}

Twitter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Twitter;

Twitter.default = Twitter;
